import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { useNavigate, useParams } from 'react-router-dom'
import { HeadingPages } from '../../../../components/HeadingPages'
import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/react'
import { CaricaturaLista } from './CaricaturaLista'

async function fetchValidacaoProCaricatura({ numero_nota }) {
  const response = await api.get('/site/v2/fluxo-layout/buscar-detalhes-ilustracao', { params: { numero_nota } })

  return response.data
}

export const ValidacaoDeCaricaturaNumeroPedido = () => {
  const params = useParams()

  const { numeroPedido } = params

  const navigate = useNavigate()

  const queryCaricatura = useQuery({
    queryKey: ['validacao-caricatura-pro', { numero_nota: numeroPedido }],
    queryFn: () => fetchValidacaoProCaricatura({ numero_nota: numeroPedido }),
    staleTime: 1000 * 60 * 5,
    onSuccess: (data) => {
      if (data.length === 0) {
        navigate('/arte-final/validacao-de-caricatura')
      }

      return data
    },

    onError: () => {
      navigate('/arte-final/validacao-de-caricatura')
    },
  })

  const { data = [] } = queryCaricatura

  return (
    <>
      <HeadingPages name={`Validação e confirmação de imagem - Pedido ${numeroPedido}`} />

      <Box mt="4" mx="auto" maxW="1300px" w="100%" experimental_spaceY={4}>
        <Flex flexDir="column" gap={4}>
          <Grid placeItems="center" templateColumns="repeat(6, 1fr)" gap={4} bg="#378BBF" color="white" fontWeight="bold">
            <GridItem w="100%" p={2} bg="#EDF2F7" color="#378BBF">
              Pedido:{' '}
              <Text color="black" as="span">
                {data[0]?.numero_pedido}
              </Text>
            </GridItem>
            <GridItem p={2}>Foto Original</GridItem>
            <GridItem p={2}>Arte Realista</GridItem>
            <GridItem p={2}>Arte Cartoon</GridItem>
          </Grid>

          <CaricaturaLista numeroNota={data[0]?.numero_nota} data={data} />
        </Flex>

        {/* <Grid templateColumns="repeat(6, 1fr)" gap={4}> */}
      </Box>
    </>
  )
}
